export const SIZE_SMALL = 'sm'
export const SIZE_MEDIUM = 'md'
export const SIZE_LARGE = 'lg'
export const SIZE_MAXIMUM = 'max'

export const SIZE_SMALL_LABEL = 'small'
export const SIZE_MEDIUM_LABEL = 'medium'
export const SIZE_LARGE_LABEL = 'large'
export const SIZE_EXTRA_LARGE_LABEL = 'extra_large'
export const SIZE_MAXIMUM_LABEL = 'full_width'
